const $inject = ['$rootScope', '$timeout'];
const lbaToastCtrl = function ($rootScope, $timeout) {
  let vm = this;

  $rootScope.$on('lbaToast:showToast', (event, data) => {
    const showFor = data.messageType === 'success' ? 3000 : 8000;
    vm.showToast = true;
    vm.message = data.message;
    vm.messageType = data.messageType || 'success';

    if (vm.showToast) {
      $timeout(() => {
        vm.showToast = false;
      }, showFor)
    }
  });
};

lbaToastCtrl.$inject = $inject;

export default lbaToastCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaToast/lbaToastCtrl.js